angular.module("appVersion", [])
.constant("version", "4.57.2026082-4.1");
